<template>
  <div class="tabla-pagos">
    <div>
    <tabla-detalles-de-pagos :pagos="pagos" :canEdit="canEdit" @deleteDetalle="confirmDelete"
      :puedeBorrarAdjuntos="puedeBorrarAdjuntos"></tabla-detalles-de-pagos>
    </div>
    <v-layout row wrap pr-5 pl-5 v-if="canEdit && $store.getters.isClubRole">
      <v-flex xs-4>
        <v-currency-field v-model="$v.monto.$model" label="Monto"
          :error-messages="this.getRequiredErrors('monto')"></v-currency-field>
      </v-flex>
      <v-flex xs-4>
        <DatePickerForm v-model="$v.fechaDePago.$model" label="Fecha de Pago"
          :error-messages="this.getRequiredErrors('fechaDePago')"></DatePickerForm>
      </v-flex>
      <v-flex xs-4 class="center-text">
        <p class="red--text mr-3" v-for="error in fileErrors" :key="error">{{ error }}</p>
        <AttachFile v-show="files.length" ref="fileInput" :description="true" @upload="uploadFiles"></AttachFile>
        <v-btn v-if="canEdit && $store.getters.isClubRole && !files.length" @click="openFileDirectory" color="#1787c9" dark class="attach-button">
          <v-icon>attach_file</v-icon>
          <span>Agregar Comprobante de Pago</span>
        </v-btn>
      </v-flex>
    </v-layout>
    <ConfirmationDialog ref="confirmDelete" :function-yes="borrarPago" title="¿Eliminar pago?"
      text="¿Desea eliminar este pago?"></ConfirmationDialog>
    <v-btn v-if="canEdit && $store.getters.isClubRole" :disabled="isSaving" color="primary" @click="uploadAllFiles">Crear</v-btn>
  </div>
</template>
<script>

import DatePickerForm from '../../../common/ui/DatePickerForm'
import { createEntityMixin } from '../../../mixins/createEntityMixin'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import ConfirmationDialog from '../../../common/ui/ConfirmationDialog'
import AttachFile from '../../../common/ui/AttachFile'
import { s3UploadMixin } from '../../../mixins/s3UploadMixin'
import TablaDetallesDePagos from './TablaDetallesDePagos'

export default {
  mixins: [createEntityMixin, validationMixin, s3UploadMixin],

  validations: {
    monto: { required },
    fechaDePago: { required },
    files: { required }
  },

  components: {
    DatePickerForm,
    ConfirmationDialog,
    AttachFile,
    TablaDetallesDePagos
  },

  filters: {
    formatAsCurrency (importe) {
      const monto = Number(importe).toLocaleString('es', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      return `$ ${monto}`
    }
  },

  props: {
    pagoId: [Number, String],
    canEdit: Boolean,
    clubPuedeBorrarAdjuntos: Boolean
  },

  data () {
    return {
      pagos: [],
      monto: null,
      fechaDePago: null,
      detalleId: null,
      asset: null,
      isSaving: false
    }
  },

  methods: {
    fetchDetalles () {
      const path = `pago/${this.pagoId}/detalles`
      this.axios
        .get(path)
        .then(response => { this.pagos = response.data })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    getPayload () {
      const payload = {
        monto: this.monto,
        fechaDePago: this.fechaDePago
      }
      if (this.hasAddedComprobante()) {
        payload.addedComprobante = this.assets
      }
      return payload
    },
    resetForm () {
      this.$v.$reset()
    },
    preSubmit () {
      this.$v.$touch()
      this.isSaving = true
    },
    postSuccessfulSubmit () {
      this.fetchDetalles()
      this.resetForms()
    },
    resetForms () {
      this.assets = []
      this.s3uploads = []
      this.files = []
      this.monto = null
      this.fechaDePago = null
      this.isSaving = false
      this.$refs.fileInput.cleanContent()
      this.resetForm()
    },
    updatedPagos () {
      this.$emit('updatedPagos')
    },
    isValidForm () {
      return !this.$v.$invalid
    },
    confirmDelete (id) {
      this.detalleId = id
      this.$refs.confirmDelete.openDialog()
    },
    borrarPago () {
      const pk = this.detalleId
      const path = `pago/detalle/${pk}/delete`
      this.axios
        .delete(path)
        .then(response => { this.postSuccessfulSubmit() })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
      this.detalleId = null
    },
    hasAddedComprobante () {
      return this.assets.length > 0
    }
  },

  computed: {
    puedeBorrarAdjuntos () {
      if (this.$store.getters.isSafRole) {
        return false
      }
      return this.clubPuedeBorrarAdjuntos && this.canEdit
    },
    createPath () {
      return `pago/${this.pagoId}/detalle/add`
    },
    headers () {
      const headers = [
        { text: 'Monto', value: 'monto' },
        { text: 'Tipo de Cambio', value: 'tipoDeCambio' },
        { text: 'Fecha de Pago', value: 'fechaDePago' }
      ]
      return headers
    },
    fileErrors () {
      return this.getRequiredErrors('files', 'Adjunto requerido.')
    }
  },

  created () {
    this.fetchDetalles()
  }

}
</script>
<style scoped>
.mensaje-sin-detalle {
  padding: 1rem;
}
.center-text {
  display: flex;
  align-items: center;
  justify-content: center;
}
.tabla-pagos {
  width: 100%;
}
.tabla-pagos tr:hover {
  background-color: rgb(200, 200, 200);
}
.tabla-pagos th {
  padding-top: 1rem;
  border-bottom: 1px solid #bbb;
}
.tabla-pagos td {
  text-align: center;
  border-bottom: 1px solid #bbb;
}
.mensaje-sin-detalle {
  padding: 1rem;
}
.center-text {
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>
